import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import DeviceGroup from "./DeviceGroup";
import { hasClosedDevices } from "utils/statusUtils";

export default function DeviceCategory({
  category,
  devices: groups,
  collapsedCategories,
  toggleCategoryCollapse,
  collapsedGroups,
  toggleGroupCollapse,
  filter,
  calculateBounds,
  setMapCenter,
  setMapZoom,
  setCalcZoom,
  // Add subscription-related props
  selectedDevices,
  toggleDevice,
  handleSave,
  saveSuccess,
  auth,
  setLoginPopupOpen,
  triggerLoginOpen,
  showSettingsState, // We'll ignore this
  selectedGroup,
  setSelectedGroup,
  ...props
}) {
  // Flatten all devices in all groups for stats
  const allDevices = groups.flatMap((group) => group.devices);

  const closedCount = allDevices.reduce(
    (acc, device) => acc + (device?.status < 1 ? 0 : 1),
    0
  );
  const openCount = allDevices.reduce(
    (acc, device) => acc + (device?.status < 1 ? 1 : 0),
    0
  );

  return (
    <div>
      <div
        onClick={() => toggleCategoryCollapse(category)}
        style={{
          background: "#436c9a",
          color: "white",
          borderTop: "1px solid white",
          borderBottom: "1px solid white",
          padding: 10,
          paddingLeft: 20,
          fontSize: 24,
          cursor: "pointer",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {category}
          {!collapsedCategories[category] ? <FaChevronDown /> : <FaChevronUp />}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            fontSize: 14,
            width: "50%",
            maxWidth: 200,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#CD5C5C",
              fontWeight: "bold",
            }}
          >
            <div>
              {category === "Road Closures"
                ? "Closed Roads:"
                : "Alerting Sirens:"}
            </div>
            <div>{closedCount}</div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              {category === "Road Closures" ? "Open Roads:" : "Idle Sirens:"}
            </div>
            <div>{openCount}</div>
          </div>
        </div>
      </div>
      {!collapsedCategories[category] &&
        groups.sort((a, b) => {
          const aHasClosed = hasClosedDevices(a);
          const bHasClosed = hasClosedDevices(b);
          
          // First sort by closed devices status
          if (aHasClosed && !bHasClosed) return -1;
          if (!aHasClosed && bHasClosed) return 1;
          
          // Then sort by group name
          return a.name.localeCompare(b.name);
        }).filter((group) => {
          if (selectedGroup) {
            return group.id === selectedGroup.id;
          }
          const groupDevicesHasFilter = group.devices.some((device) =>
            device.alias.toLowerCase().includes(filter.toLowerCase())
          );
          return group.name.toLowerCase().includes(filter.toLowerCase()) || groupDevicesHasFilter;
        }).map((group) => (
          <DeviceGroup
            key={group.id}
            group={group}
            category={category}
            collapsedGroups={collapsedGroups}
            toggleGroupCollapse={toggleGroupCollapse}
            filter={filter}
            calculateBounds={calculateBounds}
            setMapCenter={setMapCenter}
            setMapZoom={setMapZoom}
            setCalcZoom={setCalcZoom}
            selectedDevices={selectedDevices}
            toggleDevice={toggleDevice}
            handleSave={handleSave}
            saveSuccess={saveSuccess}
            auth={auth}
            setLoginPopupOpen={setLoginPopupOpen}
            triggerLoginOpen={triggerLoginOpen}
            showSettingsState={showSettingsState}
            {...props}
          />
        ))}
    </div>
  );
}
